import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=5e67a967&scoped=true"
import script from "./custom-table.vue?vue&type=script&lang=js"
export * from "./custom-table.vue?vue&type=script&lang=js"
import style0 from "./custom-table.vue?vue&type=style&index=0&id=5e67a967&scoped=true&lang=scss"
import style1 from "./custom-table.vue?vue&type=style&index=1&id=5e67a967&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67a967",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e67a967')) {
      api.createRecord('5e67a967', component.options)
    } else {
      api.reload('5e67a967', component.options)
    }
    module.hot.accept("./custom-table.vue?vue&type=template&id=5e67a967&scoped=true", function () {
      api.rerender('5e67a967', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/correspondence/custom-table.vue"
export default component.exports